import React from 'react'
import './testimonilas.css'
import AVTR1 from '../../assets/i1.jpg'
import AVTR2 from '../../assets/i2.jpg'
import AVTR3 from '../../assets/i3.jpg'
import AVTR4 from '../../assets/i4.jpg'

import { Navigation, Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const data = [
  {
    avatar: AVTR1,
    name: 'Photography',
    review: 'Photography is my creative outlet and a way to freeze time in captivating frames. From vibrant cityscapes to intimate portraits, I love capturing the essence of life\'s moments. Through photography, I aim to inspire, evoke emotions, and preserve memories that stand the test of time.'
  },
  {
    avatar: AVTR2,
    name: 'Video Editing',
    review: 'Video editing is my forte. Meticulously crafting visual narratives, I bring raw footage to life, adding effects, transitions, and sound to create compelling stories. My attention to detail and artistic flair allow me to produce polished videos that engage audiences and leave a lasting impact.'
  },
  {
    avatar: AVTR3,
    name: 'Reading',
    review: 'Books are my escape and inspiration. Delving into various genres, I immerse myself in the worlds created by authors. Reading fuels my imagination, broadens my knowledge, and fosters a love for storytelling. It\'s a gateway to endless possibilities and endless learning.'
  },
  {
    avatar: AVTR4,
    name: 'Machine Learning',
    review: 'Machine Learning fascinates me, and I am eager to explore this field further. Though I currently lack expertise, I am enthusiastic about diving into the world of algorithms, data analysis, and artificial intelligence. I aim to study and contribute to cutting-edge advancements that shape the future.'
  }
]

const Testimonilas = () => {
  return (
    <section id="interests">
      <h5>Passions and Hobbies</h5>
      <h2>My Interests</h2>

      <Swiper className="container testimonials__container"
      // install Swiper modules
      modules={[Navigation, Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      // navigation
      pagination={{ clickable: true, swipeable: true }}
      
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
      >
        {
          data.map(({avatar, name, review}, index) => {
            return(
              <SwiperSlide className="testimonial">
                <div className="client__avatar">
                  <img src={avatar} alt={name} />
                </div>
                <h3 className='client__name'>{name}</h3>
                <small className='client__review'>{review}</small>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonilas